<div class="container bg-primary d-lg-none d-block">
  <fgb-barcode></fgb-barcode>
</div>

<div class="nav-container">
  <fgb-payment-navbar></fgb-payment-navbar>
</div>

<div class="container mt-4">
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
